module.exports = __webpack_public_path__ + "static/6-36f8fb6e0c9b60c44e5bdfe04daf10f7.jpg";